import http from '@/http';

export default new class shoppingCartService {
    count(){
        return http.get('shoppingCart/count');
    }
    add(formData){
        return http.post('shoppingCart/add',formData);
    }
    update(formData){
        return http.put('shoppingCart/update',formData);
    }
    remove(shoppingCartIdx){
        return http.delete('shoppingCart/remove/'+shoppingCartIdx);
    }
    shoppingCart(couponCode){
        let append = couponCode ? "/"+couponCode : "";
        return http.get('shoppingCart/shoppingCart'+append);
    }
    syncBasketItems(){
        return http.get('shoppingCart/sync');
    }
    validateCouponCode(couponCode){
        return http.get('shoppingCart/validateCouponCode/'+couponCode);
    }
}